module.exports = __webpack_public_path__ + "img/galery28.df4201ad.jpg";